import ReactDOM from 'react-dom'
import './index.css'
import './assets/css/style.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import AuthContext, { AuthService } from './msal/msal'
import { ThemeProvider } from '@material-ui/core/styles'
import defaultTheme from './theme/defaultTheme'
import store from './redux/store'
import { Provider } from 'react-redux'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import 'moment/locale/es'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const timeToWaitForTokenInMilliseconds = 1000
const msal = new AuthService(null)

const LoadApp = (isAuthenticated, msal) => {
  if (!isAuthenticated) {
    msal.signIn().then((r) => {})
  } else {
    ReactDOM.render(
      <ThemeProvider theme={defaultTheme}>
        <AuthContext.Provider value={msal}>
          <Provider store={store}>
            <MuiPickersUtilsProvider utils={MomentUtils} locale="es">
              <App />
            </MuiPickersUtilsProvider>
          </Provider>
          ,
        </AuthContext.Provider>
        ,
        <ToastContainer
          position="top-right"
          autoClose={8000}
          hideProgressBar={false}
          closeOnClick={true}
          pauseOnHover={true}
          draggable={true}
          theme="colored"
        />
      </ThemeProvider>,
      document.getElementById('root')
    )
  }
}

const IsAuthenticatedTimeOut = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(msal.isAuthenticated())
    }, timeToWaitForTokenInMilliseconds)
  })
  return promise
}

IsAuthenticatedTimeOut(msal).then((isAuthenticated) => LoadApp(isAuthenticated, msal))

reportWebVitals(console.log)
